import { useState } from 'react';

const useMachine = (machine, initialState) => {
  const [{ machineState, additionalState }, setState] = useState({
    additionalState: {},
    machineState: initialState || machine.initial
  });

  const transition = (action, payload) => {
    if (action in machine[machineState]) {
      setState(s => ({
        additionalState: payload && { ...s.additionalState, ...payload },
        machineState: machine[machineState][action]
      }));
    } else {
      // prettier-ignore
      console.error( // eslint-disable-line no-console
        `${action} is not a valid transition for ${machineState}:${JSON.stringify(
          machine[machineState],
          null,
          4
        )}`
      );
    }
  };

  return [machineState, transition, additionalState];
};

export default useMachine;
